import { toast } from 'react-toastify';
import axios from 'axios';
import configData from '../config';
// show toaster message : type consists (success,warning,error);
export const showToast = (type, message) => {
    if(type === 'success') {
        toast.success(message);
    } else if(type === 'error') {
        toast.error(message);
    } else if(type === 'info') {
        toast.info(message);
    } else if(type === 'warning') {
        toast.warn(message);
    } else {
        toast(message);
    }
}

// set axios api call with base-url and headers data.
export const axiosSetting = (dataStr) => {
    return axios.create({
        baseURL: configData.baseApiUrl,
        headers: { Authorization: dataStr}
    });
}